import { Seo } from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { CtaBanner } from "@/components/CtaBanner";
import { ProductCard } from "@/components/ProductCard";
import { SITE, IMAGES, PRODUCT_KEYS } from "@/config/site";

export default function ProductsPage() {
  const products = PRODUCT_KEYS.map((key) => ({
    key,
    ...SITE.products[key],
    image: IMAGES[key],
  }));

  return (
    <>
      <Seo
        title="Products — ReelCopy AI, EduHub AI & Proxavi | Tedmo Services"
        description="Products by Tedmo Services: ReelCopy AI (video archiving with AI caption cleanup), EduHub AI (K-12 STEM and literacy platform), and Proxavi (advanced health AI operating system for regulated care)."
        path="/products"
      />

      <section className="py-20 border-b border-line" data-testid="products-hero">
        <div className="max-w-6xl mx-auto px-6">
          <span className="font-mono-sub text-xs text-royal uppercase tracking-wider font-bold">
            Proprietary Technology
          </span>
          <h1
            data-testid="products-page-title"
            className="font-poster text-4xl sm:text-5xl font-extrabold text-steel mt-2 max-w-3xl leading-tight"
          >
            Products by Tedmo
          </h1>
          <p className="text-lg text-ink mt-6 max-w-2xl leading-relaxed">
            Alongside client work, we build our own platforms. Access and
            availability are shared on request — leave your email on any product
            to be notified when it opens up.
          </p>
        </div>
      </section>

      <section className="py-16 max-w-6xl mx-auto px-6" data-testid="products-list">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((product, i) => (
            <Reveal key={product.key} delay={i * 80}>
              <ProductCard product={product} />
            </Reveal>
          ))}
        </div>
      </section>

      <CtaBanner title="Interested in ReelCopy AI, EduHub AI, or Proxavi?" />
    </>
  );
}
